import React from 'react';
import { Link, useWindowSize } from 'vindi-ds-components';
import Header from '@templates/header';

function HeaderChargesPending() {
  const { isMobile } = useWindowSize();

  return (
    <>
      {isMobile ? (
        <Header.Mobile
          links='/admin/reports'
          title='Cobranças aguardando pagamento'
        />
      ) : (
        <Header.WithoutAction
          links={[
            <Link href='/admin/dashboard'>Início</Link>,
            <Link href='/admin/reports'>Relatórios</Link>,
          ]}
          title='Cobranças aguardando pagamento'
        />
      )}
    </>
  );
}

export default HeaderChargesPending;
